<template>
    <div class="md:flex justify-between  gap-4 ">
        <div class="md:w-1/2 bg-white text-black" >
            <div class="px-4 py-4  " variant="outlined" rounded="0">
                <div class="text-md justify-center items-center flex">
                    <i class="flaticon-atm mx-2 text-lg"></i>
                    <p>Recharge with CRYPTO (Transaction fees)</p>
                </div>
                <div class="text-sm px-2 pt-4">
                    <span class="flex py-1">
                        <i class="flaticon-check mx-2"></i>
                        1. Choose the currency ( Bitcoin, USDT, Litecoin or BUSDT ).
                    </span>
                    <span class="flex py-1">
                        <i class="flaticon-check mx-2"></i>
                        2. Input the amount you want to deposit, and create the order.
                    </span>
                    <span class="flex py-1">
                        <i class="flaticon-check mx-2"></i>
                        3. Make your payment using the right network.
                    </span>
                    <span class="flex py-1">
                        <i class="flaticon-check mx-2"></i>
                        4. Can take between 5 - 30 minutes before the payment is processed.
                    </span>
                </div>
            </div>
        </div>
        <div class="md:mt-0 md:w-1/2 text-sm bg-white text-black">
            <div class="border-0 " variant="outlined" rounded="0">
                <div class="px-4 py-4">
                    <div class="">
                        <div class="w-full text-sm">
                            <v-col class="flex justify-between px-0 py-0 my-2">
                                <p>Crypto currencies</p>
                                <p>Input Amount (USD)</p>
                            </v-col>
                            <v-col class="px-0 p-0">
                                <div class="flex">
                                    <div class="w-1/2">
                                        <v-combobox v-model="selectedItem" :items="items" placeholder="Select"
                                            rounded="0" variant="outlined" style="outline: none;" density="compact"
                                            class="bg-white text-black text-sm" :hide-no-data="false">
                                            <template v-slot:no-data>
                                                <v-list-item density>
                                                    <v-list-item-title density="compact" variant="disabled">
                                                        <p class="text-sm text-gray-600 text-center">Not found</p>
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </template>
                                        </v-combobox>
                                    </div>
                                    <div class="w-1/2 ml-5">
                                        <v-text-field type="number" v-model="amount.input" variant="outlined"
                                            rounded="0" @change="inputChangeHandler" density="compact"
                                            style="outline:none;"></v-text-field>
                                    </div>
                                </div>
                            </v-col>
                        </div>

                        <div class="w-full text-sm">
                            <v-col class="flex justify-between px-0 py-0 my-2">
                                <p>Estimated Amount (Coin)</p>
                            </v-col>
                            <v-col class="px-0 py-0">
                                <div class="flex">
                                    <div class="w-1/2">
                                        <v-text-field type="number" v-model="amount.est" variant="outlined" rounded="0"
                                            density="compact" readonly style="outline:none"></v-text-field>
                                    </div>
                                    <div class="w-1/2 ml-5 text-center">
                                        <v-btn class="bg-dark text-light text-xs shadow-lg" @click="openDialogHandler"
                                            :data-bs-toggle="amount.est > 0 ? 'modal' : ''"
                                            data-bs-target="#transactionInfoModal">
                                                Create Invoice
                                        </v-btn>
                                    </div>
                                </div>
                            </v-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <TransactionInfoModal v-if="selectedItem" :transferInfo="transferInfo" />
    </div>
</template>

<script setup>
import { ref, watchEffect } from 'vue';
import { useBitcartStore } from '@/stores';
import { storeToRefs } from 'pinia';
import TransactionInfoModal from './Modals/TransactionInfoModal.vue';
const bitcartStore = useBitcartStore()
const payment = storeToRefs(bitcartStore)
var selectedItem_prev = ""
const selectedItem = ref(null)
const items = ref([])
const amount = ref({
    input: 0,
    est: 0
})

watchEffect(() => {
    bitcartStore.getWallets()
}, [])

watchEffect(() => {
    items.value = payment.wallets.value.map(item => item.label)
    selectedItem.value = items.value[0]
}, [payment.wallets.value])

watchEffect(() => {
    // Perform side effects when selectedItem changes
    if (selectedItem.value !== null && selectedItem.value !== undefined) {
        const wallet = payment.wallets.value.find(item => item.label === selectedItem.value)
        if (wallet !== undefined) {
            amount.value.est = (amount.value.input / wallet.rate).toFixed(8)
        }
    }
    if (!items.value.find(item => item == selectedItem.value)) {
        selectedItem.value = selectedItem_prev
    }
    else {
        selectedItem_prev = selectedItem.value
    }
}, [selectedItem.value]);

const inputChangeHandler = () => {
    const wallet = payment.wallets.value.find(item => item.label === selectedItem.value)
    if (wallet !== undefined)
        amount.value.est = (amount.value.input / wallet.rate).toFixed(8) 
}
const transferInfo = ref(null)
const openDialogHandler = () => {
    transferInfo.value = null

    if (amount.value.est > 0) {
        bitcartStore.createBitcartTransaction(selectedItem.value, amount.value.input, amount.value.est).then(res => {
            if (res) {
                transferInfo.value = res
                bitcartStore.loadTransactionHistory({from: 0, count: 50})
            }
        })
    }

}
watchEffect(() => {
    amount.value.input = Math.max(0, amount.value.input)
}, [amount.value])
</script>